export const RACE_SET_IS_SOON = "RACE_SET_IS_SOON";

export function raceSetIsSoon(raceId) {
  return { type: RACE_SET_IS_SOON, raceId };
}
